export default __webpack_public_path__ + "static/media/nocturne.20427fdb.png";